<script setup lang="ts">
import type { NuxtError } from '#app';

const props = defineProps<{ error: NuxtError }>();
const errors = [
    {
        code: 404,
        msg: 'صفحه‌ای که به دنبال آن هستید در دسترس نیست!',
        desc: 'ممکن است آدرس نادرست باشد یا صفحه جابه‌جا شده باشد. برای ادامه می‌توانید به صفحه اصلی بازگردید یا از منو مسیر مورد نظر را انتخاب کنید.',
        img: '/img/errors/error404.png',
    },
    {
        code: 500,
        msg: 'مشکلی در سرور رخ داده است!',
        desc: 'در حال حاضر اختلالی در سیستم وجود دارد و تیم فنی در حال بررسی است. لطفاً چند دقیقه دیگر دوباره تلاش کنید یا در صورت نیاز فوری، با پشتیبانی تماس بگیرید.',
        img: '/img/errors/error500.png',
    }
] as const;

const errInfo = errors.find(e => e.code === props.error.status || e.code === 500);

useHead({
  title: props.error.status === 404 ? 'Page not found' : 'Something went wrong',
  meta: [{ name: 'robots', content: 'noindex' }],
});
</script>

<template>
    <NuxtLayout>
        <div class="w-full flex flex-col justify-center items-center gap-3 px-4">
            <img 
                width="500"
                :src="errInfo?.img"
                alt="صفحه مورد نظر پیدا نشد."
                class="w-[80%] lg:w-[40%]"
            />
            <h1 class="text-center">{{ errInfo?.msg }}</h1>
            <p class="w-full lg:w-1/2 text-center text-gray-500">{{ errInfo?.desc }}</p>
            <Button to="/" class="my-12" link>بازگشت به صفحه اصلی</Button>
        </div>
    </NuxtLayout>
</template>